import { clearSantralWizardSnapshot } from './santralWizardStorage';
import { clearOnServisWizardSnapshot } from './onServisWizardStorage';
import { clearManualWizardSnapshot } from './manualWizardStorage';

export function hasResumableWizardSession() {
  return false;
}

export function extractCachedTaslakForManualStart() {
  return { taslakId: null, customer: null };
}

export function clearServiceRecordCreateCaches() {
  clearSantralWizardSnapshot();
  clearOnServisWizardSnapshot();
  clearManualWizardSnapshot();
}

export function prepareManualServiceRecordCreate() {
  clearServiceRecordCreateCaches();
  return { taslakId: null, customer: null };
}

export function navigateToManualServiceRecordCreate(navigate) {
  clearServiceRecordCreateCaches();
  navigate('/service-records/create');
}
